import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import color from 'src/utils/colors';
import { CheckedDocumentsIcon, RightArrow } from 'src/components/SvgIcons/SvgIcons';
import { useProfileSummaryStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';

interface BlankRequirementSectionProps {
  onAddClick: () => void;
}

export const BlankRequirementSection: React.FC<BlankRequirementSectionProps> = ({ onAddClick }) => {
  const isReadOnly = useProfileSummaryStore((s) => s.isReadOnly);
  return (
    <Flex
      flexDirection="column"
      sx={{
        borderRadius: '8px',
        border: `1px solid ${color.graysSecondary}`,
        padding: '24px',
        marginTop: '32px',
        height: '172px'
      }}
    >
      <div
        style={{
          padding: '14px',
          backgroundColor: color.graysPrimary,
          borderRadius: '50%',
          height: '60px',
          width: '60px'
        }}
      >
        <CheckedDocumentsIcon
          style={{
            height: '32px',
            width: '32px'
          }}
        />
      </div>
      <Text
        variant="h7"
        sx={{
          marginBottom: '4px',
          marginTop: '16px',
          fontSize: '16px'
        }}
      >
        No requirements?
      </Text>
      {!isReadOnly && (
        <div
          role="button"
          style={{
            width: 'fit-content',
            cursor: 'pointer'
          }}
          onClick={() => onAddClick()}
        >
          <Text
            variant="body2"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Add a new requirement for this profile
            <RightArrow
              style={{
                height: '12px',
                width: '12px'
              }}
            />
          </Text>
        </div>
      )}
    </Flex>
  );
};
